import React, { useState } from 'react';
import { View, ViewStyle, ScrollView, TouchableWithoutFeedback } from 'react-native';
import { SlideOperation } from '@/component/SlideOperation';
import Radio from '@/component/Radio';
import Image from '@kds/image';
import { styles } from '@/common/style';
import { style } from './style';
import Flex from '@/component/atom/Flex';
import { $k18n } from '@/common/i18n';
import ProductCard from '../ProductCard';
import IconDelete from '@/assets/icon/icon_delete.png';
import { LogShow } from '@/component/ViewVisible/ViewVisible';
import { logger } from '@/common/log';

import { useShopInfoStore } from '../store/shopInfoStore';
import { ReturnT } from '@/page/myShoppingCar/views/hooks/usePageInfo';
import { KText, KView } from '@/component/RtlLayout';
import empty from '@/assets/images/empty.png';
import iconClose from '@/assets/icon/kibt_profile_profilemasterstate_cancel_24.png';
import { Toast } from '@kibt/meta-ui-krn';

export type ShopCartItem = ReturnT['cartShopList'][number];
interface IProps {
    style?: ViewStyle;
    shopCartItem?: ShopCartItem;
    handleDelete?: (ids: number) => void;
    handleCheck?: (ids: number[], checked: boolean, isSingleCheck?: boolean) => Promise<any>;
    handleSetCartItemNum?: (cartItemId: number, num: number, selected: boolean) => Promise<any>;
    height?: number;
    onClose?: () => void;
}
export default function ShopCard(props: IProps) {
    const { shopCartItem, handleDelete, handleCheck, handleSetCartItemNum, height = null } = props;
    const { storeCartItem } = useShopInfoStore((store) => {
        return {
            storeCartItem: store.storeCartItem,
        };
    });

    // const selectedInsufficient = useStore((s) => s.selectedInsufficient);
    const selectedInsufficient = false; // todo

    const shopDiscount = shopCartItem?.shopEvaluate?.shopDiscount;
    const [openedCartItemId, setOpenedCartItemId] = useState(null);
    // const isAllEddittingSelected = shopCartItem?.cartItemList?.every?.((item) => edittingList.includes(item.cartItemId));
    const productList = shopCartItem?.cartItemList || [];
    const isAllSelected = productList.filter((v) => !([2, 3, 4].indexOf(v.status) > -1)).every((v) => v.isSelected);
    const isAllDisabled = productList.every((v) => [2, 3, 4].indexOf(v.status) > -1);
    const selectedCartItems = productList.filter((v) => v.isSelected);

    function handleAllCheck(checked) {
        console.log(checked, 'checked');
        let ids;
        if (!checked) ids = productList.map((v) => v.cartItemId);
        else ids = productList.filter((v) => !([2, 3, 4].indexOf(v.status) > -1)).map((v) => v.cartItemId);
        if (ids.length > storeCartItem.selectedLimit) {
            return Toast.show({ text: $k18n({ text: '最多选择{num}个商品', params: { num: storeCartItem.selectedLimit } }) });
        }
        handleCheck(ids, !isAllSelected);
        logger.sendClick({
            action: 'CART_CARD_SELECTALL',
            params: {
                merchant_id: shopCartItem?.merchantId,
            },
        });
    }

    return (
        <LogShow
            action="CART_CARD"
            params={{
                merchant_id: shopCartItem?.merchantId,
                item_info: shopCartItem?.cartItemList.map((v) => ({
                    item_id: v.cartItemId,
                    total_price: v.skuPrice,
                    sku_id: v.skuId,
                    sku_num: v.skuQuantity,
                    sku_status: v.status,
                })),
            }}
        >
            <View
                style={[
                    style.cardBox,
                    styles(props.style),
                    {
                        height,
                    },
                ]}
            >
                <View style={[style.navbar]}>
                    {productList.length ? (
                        <Radio
                            checked={isAllDisabled ? false : isAllSelected}
                            disabled={isAllDisabled}
                            onChecked={(checked) => {
                                if (isAllDisabled) return;
                                handleAllCheck(checked);
                            }}
                        />
                    ) : (
                        <KView />
                    )}
                    <KText style={{ fontSize: 18, fontStyle: 'normal', fontWeight: '700', color: 'black', flexGrow: 1, textAlign: 'center' }}>
                        {$k18n({ text: '已加购商品' })}
                    </KText>
                    <TouchableWithoutFeedback onPress={props.onClose}>
                        <Image style={{ width: 24, height: 24 }} source={iconClose} />
                    </TouchableWithoutFeedback>
                </View>
                {productList.length ? (
                    <ScrollView>
                        {productList.map((v, idx) => {
                            const isLast = idx === productList.length - 1;
                            const disabled = [2, 3, 4].indexOf(v.status) > -1;
                            return (
                                <View key={`${v.itemId}_${v.skuId}`}>
                                    <SlideOperation
                                        index={idx}
                                        rightActionWidth={68}
                                        customStyle={{ containerHeight: null }}
                                        closeAfterClickedBtn={false}
                                        close={openedCartItemId !== v.cartItemId}
                                        onClose={() => {
                                            setOpenedCartItemId(null);
                                        }}
                                        onOpen={() => {
                                            setOpenedCartItemId(v.cartItemId);
                                        }}
                                        rightActions={[
                                            {
                                                text: $k18n({ text: '删除', desc: 'k_274366' }),
                                                bgColor: 'rgb(255, 73, 6)',
                                                render: () => <Image style={styles({ width: 24, height: 24 })} source={IconDelete} />,
                                                onClick: () => {
                                                    handleDelete(v.cartItemId);
                                                    logger.sendClick({
                                                        action: 'CART_CARD_DELETE',
                                                        params: {
                                                            merchant_id: shopCartItem?.merchantId,
                                                            sku_id: v.skuId,
                                                        },
                                                    });
                                                },
                                            },
                                        ]}
                                    >
                                        <Flex flex={'flexRowCenter'} style={{ marginTop: 16, marginBottom: isLast ? 24 : 0, paddingHorizontal: 19 }}>
                                            <Radio
                                                style={styles({ height: '100%', paddingRight: 14 })}
                                                checked={v.isSelected}
                                                disabled={v.disabled}
                                                onChecked={(checked) => {
                                                    if (v.disabled || (checked && disabled)) return;
                                                    handleCheck([v.cartItemId], checked, true);
                                                    logger.sendClick({
                                                        action: 'CART_CARD_CHOSEE',
                                                        params: {
                                                            merchant_id: shopCartItem?.merchantId,
                                                            sku_id: v.skuId,
                                                            checked,
                                                        },
                                                    });
                                                }}
                                            />
                                            <LogShow
                                                action="CART_CARD_ITEM"
                                                params={{
                                                    merchant_id: shopCartItem?.merchantId,
                                                    item_id: v.itemId,
                                                    sku_id: v.skuId,
                                                    total_price: v.skuPrice,
                                                    sku_num: v.skuQuantity,
                                                    sku_statas: v.status,
                                                }}
                                            >
                                                <ProductCard
                                                    style={{ paddingRight: 18 }}
                                                    pruductItem={v}
                                                    disabled={disabled}
                                                    onGoDetail={() => {
                                                        logger.sendClick({
                                                            action: 'CART_CARD_ITEM',
                                                            params: {
                                                                merchant_id: shopCartItem?.merchantId,
                                                                item_id: v.itemId,
                                                                sku_id: v.skuId,
                                                                total_price: v.skuPrice,
                                                                sku_num: v.skuQuantity,
                                                                sku_statas: v.status,
                                                            },
                                                        });
                                                    }}
                                                    onSkuNumChange={(num, type) => {
                                                        const selected = v.isSelected;
                                                        handleSetCartItemNum?.(v.cartItemId, num, selected);
                                                        if (type !== undefined) {
                                                            logger.sendClick({
                                                                action: 'CART_CARD_CHANGENUM_BTN',
                                                                params: {
                                                                    merchant_id: shopCartItem?.merchantId,
                                                                    num,
                                                                    type,
                                                                },
                                                            });
                                                        } else {
                                                            logger.sendClick({
                                                                action: 'CART_CARD_CHANGENUM',
                                                                params: {
                                                                    merchant_id: shopCartItem?.merchantId,
                                                                    num,
                                                                },
                                                            });
                                                        }
                                                    }}
                                                />
                                            </LogShow>
                                        </Flex>
                                    </SlideOperation>
                                </View>
                            );
                        })}
                    </ScrollView>
                ) : (
                    <KView
                        style={{
                            height: '80%',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Image source={empty} style={{ width: 96, height: 96 }} />
                        <KText>{$k18n({ id: 'k_252269', text: '暂无商品' })}</KText>
                    </KView>
                )}
            </View>
        </LogShow>
    );
}
